module.exports = __webpack_public_path__ + "img/HQ-PA10W1CH_ALL.6f9e095f.jpg";